import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { memo } from "react";
import { useSelector } from "react-redux";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
import { useImageContentControlsContext } from "~/components/AssetModalV2/Content/ImageContentControlsContextProvider";
import { useNoPreviewInVisualizer } from "~/hooks/useNoPreviewInVisualizer";
import { centralizedClipIsPDFTypeSelector, centralizedClipStatusSelector, centralizedClipTypeSelector } from "~/store/centralizedClip/selectors";
export const AssetModalContentDesktopLayout = /*#__PURE__*/ memo((param)=>{
    let { header, content, leftPanel, footer } = param;
    const { showContentLeftPanel } = useAssetModalPanel();
    const { zoom } = useImageContentControlsContext();
    const clipType = useSelector(centralizedClipTypeSelector);
    const isPdfRenderedFile = useSelector(centralizedClipIsPDFTypeSelector);
    const isImage = (clipType === ClipType.photo || clipType === ClipType.animated) && !isPdfRenderedFile;
    const clipStatus = useSelector(centralizedClipStatusSelector);
    const { noPreviewInVisualizer } = useNoPreviewInVisualizer();
    const isProcessing = noPreviewInVisualizer || clipStatus === "transcoding";
    const isZoomed = zoom > 1;
    // For images and processing: use overlay layout only when zoomed or processing, otherwise use grid layout
    if (isImage && isZoomed || isProcessing) {
        return /*#__PURE__*/ _jsx("div", {
            className: "relative size-full",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "relative h-full overflow-hidden bg-grey-1",
                children: [
                    content,
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute inset-x-0 top-0 z-10 flex h-16 items-center px-4 text-grey-10 before:absolute before:inset-0 before:-z-10 before:bg-grey-1 before:opacity-70",
                        children: header
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute inset-x-0 bottom-0 z-10 flex h-16 items-center px-4 text-grey-10 before:absolute before:inset-0 before:-z-10 before:bg-grey-1 before:opacity-70",
                        children: footer
                    })
                ]
            })
        });
    }
    // For PDFs and videos:
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid size-full grid-rows-[auto_1fr_auto]",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-span-full flex h-16 items-center p-4 text-grey-10",
                children: header
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid min-h-0 transition-all duration-300 ease-in-out",
                style: {
                    gridTemplateColumns: showContentLeftPanel ? "264px 1fr" : "0 1fr"
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative min-h-0 overflow-hidden transition-opacity duration-300 ease-in-out",
                        style: {
                            opacity: showContentLeftPanel ? 1 : 0
                        },
                        children: showContentLeftPanel && /*#__PURE__*/ _jsx("div", {
                            className: "absolute inset-0 w-[264px] px-4",
                            children: leftPanel
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-0 flex-col p-6",
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-span-full flex h-16 items-center p-4 text-grey-10",
                children: footer
            })
        ]
    });
});
AssetModalContentDesktopLayout.displayName = "AssetModalContentDesktopLayout";
